import UserReportGrid from './UserReportGrid';
export default UserReportGrid;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/UserReportGrid/index.js